export default __webpack_public_path__ + "static/jaroslaww-fd312f2ae8a77baabcbb17adfcb34b47.jpg";